/** Route paths for Prompt Pulse sidebar + redirects (mirrors SEC_FILING_ROUTE_PATHS pattern). */
export const GEO_ROUTE_PATHS = [
  '/prompt-pulse',
  '/prompt-pulse/insights',
  '/prompt-pulse/prompts',
];

export const GEO_ROUTES = {
  root: '/prompt-pulse',
  insights: '/prompt-pulse/insights',
  prompts: '/prompt-pulse/prompts',
};

export const isPromptPulseNavActive = (pathname) => GEO_ROUTE_PATHS.some(
  (path) => pathname === path || pathname.startsWith(`${path}/`),
);

/** @deprecated Use isPromptPulseNavActive */
export const isGeoAnalyticsNavActive = isPromptPulseNavActive;

/** Default date window for Insights (KPIs, Mention Share Over Time, etc.). */
export const DEFAULT_GEO_INSIGHTS_DAYS = 7;

/** Default metrics window for the Prompts table. */
export const DEFAULT_GEO_PROMPTS_DAYS = 30;

/** @deprecated Use DEFAULT_GEO_INSIGHTS_DAYS or DEFAULT_GEO_PROMPTS_DAYS */
export const DEFAULT_GEO_DAYS = DEFAULT_GEO_INSIGHTS_DAYS;

export function getDefaultGeoDays(mode = 'insights') {
  return mode === 'prompts' ? DEFAULT_GEO_PROMPTS_DAYS : DEFAULT_GEO_INSIGHTS_DAYS;
}

export const DEFAULT_GEO_PROMPTS_PAGE = 1;
export const DEFAULT_GEO_PROMPTS_PAGE_SIZE = 25;
export const GEO_PROMPTS_PAGE_SIZE_OPTIONS = [25, 35, 50];

export const GEO_DATE_RANGE_OPTIONS = [
  { value: 7, label: 'Last 7 days' },
  { value: 15, label: 'Last 15 days' },
  { value: 30, label: 'Last 30 days' },
  { value: 60, label: 'Last 60 days' },
  { value: 90, label: 'Last 90 days' },
  { value: 'custom', label: 'Custom range' },
];

export const GEO_SENTIMENT_TYPE_OPTIONS = [
  { value: 'all', label: 'All sentiments' },
  { value: 'positive', label: 'Positive' },
  { value: 'neutral', label: 'Neutral' },
  { value: 'negative', label: 'Negative' },
  { value: 'n/a', label: 'N/A' },
];

export const GEO_PAGE_TITLE = 'Prompt Pulse';
